<svg preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  @for (r of radii; track r) {
    <circle cx="50%" cy="50%" [attr.r]="r" />
  }
</svg>
